import * as tslib_1 from "tslib";
import { OnInit, ElementRef } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { startWith, map } from 'rxjs/operators';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import JsFileDownloader from 'js-file-downloader';
var ModalFormMonthlyPaymentComponent = /** @class */ (function () {
    function ModalFormMonthlyPaymentComponent(errorsService, snackBar, formBuilder, reportService, dialogRef) {
        this.errorsService = errorsService;
        this.snackBar = snackBar;
        this.formBuilder = formBuilder;
        this.reportService = reportService;
        this.dialogRef = dialogRef;
        this.selectedCustomers = [];
        this.customerControl = new FormControl();
        this.customers = [];
        this.id = [];
        this.separatorKeysCodes = [ENTER, COMMA];
    }
    ModalFormMonthlyPaymentComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.formGroup = this.formBuilder.group({
            beginDate: [null, [Validators.required]],
            endDate: [null, [Validators.required]],
            customersInput: [null, []],
        });
        this.reportService.listCustomers().subscribe(function (response) {
            response.map(function (item) {
                _this.customers.push(item);
            });
        }, function (error) {
            console.log(error);
        });
        this.filteredCustomers = this.customerControl.valueChanges.pipe(startWith(''), map(function (customer) { return (customer ? _this._filter(customer) : _this.customers.slice(0, 20)); }));
    };
    ModalFormMonthlyPaymentComponent.prototype._filter = function (customer) {
        var _this = this;
        var remove = String(customer).replace(/[.-]/g, '');
        if (typeof remove !== 'string') {
            return;
        }
        return this.customers
            .filter(function (c) { return !_this.selectedCustomers.includes(c); })
            .filter(function (c) {
            return (String(c.cpf) + " " + String(c.name)).toLowerCase().includes(remove.toLowerCase());
        })
            .slice(0, 20);
    };
    ModalFormMonthlyPaymentComponent.prototype.removeCustomer = function (customer) {
        var index = this.selectedCustomers.indexOf(customer);
        if (index >= 0) {
            this.selectedCustomers.splice(index, 1);
        }
    };
    ModalFormMonthlyPaymentComponent.prototype.selected = function (event) {
        this.selectedCustomers.push(event.option.value);
        this.customerInput.nativeElement.value = '';
        this.customerControl.setValue(null);
    };
    ModalFormMonthlyPaymentComponent.prototype.cancel = function () {
        this.dialogRef.close('cancel');
    };
    ModalFormMonthlyPaymentComponent.prototype.submit = function () {
        var _this = this;
        var customers = this.selectedCustomers.map(function (c) { return c.customerId; });
        if (!this.formGroup.valid) {
            this.snackBar.open('Preencha corretamente os campos e tente novamente.');
            return false;
        }
        if (this.selectedCustomers.length) {
            this.filter = "monthly-payment?customersIds=" + customers + "&beginDate=" + this.formGroup.value.beginDate + "&endDate=" + this.formGroup.value.endDate;
        }
        else {
            this.filter = "monthly-payment?beginDate=" + this.formGroup.value.beginDate + "&endDate=" + this.formGroup.value.endDate;
        }
        this.reportService
            .createReport(this.filter)
            .then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                // eslint-disable-next-line no-new
                new JsFileDownloader({
                    url: response.fileUrl,
                    nameCallback: function () {
                        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                        return 'Relatório de Mensalidade.' + response.fileUrl.split('.').splice(5, 5).join('.');
                    },
                });
                return [2 /*return*/];
            });
        }); })
            .catch(function (error) {
            _this.snackBar.open(error.message);
        });
    };
    return ModalFormMonthlyPaymentComponent;
}());
export { ModalFormMonthlyPaymentComponent };
